import React from 'react';
import banner from "../../Asset/CONTACT US BANNER_UPDATED.png";
import Contactus from '../Ui/Contactus';
import { IoMdCall, IoMdMail } from 'react-icons/io';

const Contactuspage = () => {
  return (
    <div className='w-full '>
      {/* Banner Section */}
      <section className="w-full">
        <img src={banner} alt="Contact Us Banner" className="w-full object-cover" />
      </section>

      {/* Contact Us Form Section */}
      <div className='-mt-5'>
        <Contactus />
      </div>
    
    </div>
  );
};

export default Contactuspage;
